"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.regexp.search");
var _merchant = require("@/api/merchant");
var _status = require("@/api/iot/status");
var _deviceWarnLog = require("@/api/iot/deviceWarnLog");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _default = {
  components: {
    customPage: _customPage.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {
        merchant_id: '',
        terminal_no: '',
        fault_type: '',
        fix_status: ''
      },
      total: 0,
      tableData: [],
      editItem: null,
      faultTypeList: [],
      fixStatusList: [],
      merchantList: []
    };
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getFaultTypeList();
    this.getFixStatusList();
    this.search();
  },
  methods: {
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getFaultTypeList: function () {
      var _getFaultTypeList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (0, _status.getFaultTypeList)();
              case 2:
                res = _context2.sent;
                if (res) {
                  this.faultTypeList = res;
                }
              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function getFaultTypeList() {
        return _getFaultTypeList2.apply(this, arguments);
      }
      return getFaultTypeList;
    }(),
    getFixStatusList: function () {
      var _getFixStatusList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return (0, _status.getFixStatusList)();
              case 2:
                res = _context3.sent;
                if (res) {
                  this.fixStatusList = res;
                }
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function getFixStatusList() {
        return _getFixStatusList2.apply(this, arguments);
      }
      return getFixStatusList;
    }(),
    getList: function getList(flag) {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _deviceWarnLog.deviceWarnLogList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.loading = false;
        _this.tableData = res.data || [];
        _this.total = res.total;
      });
    },
    // 修改故障处理状态
    editFixStatus: function editFixStatus(item) {
      var _this2 = this;
      var fix_status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
      var str = fix_status == 1 ? '故障处理完成' : '故障处理中';
      this.$confirm("".concat(str), '故障处理', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        var param = {
          id: item.id,
          fix_status: fix_status
        };
        (0, _deviceWarnLog.saveDeviceWarnLog)(param).then(function (res) {
          _this2.getList(true);
        });
      }).catch(function () {});
    },
    // 检测租借状态
    chkStatusType: function chkStatusType(status) {
      var type = 'danger';
      if (status == 1) {
        type = 'success';
      } else if (status == 2) {
        type = 'info';
      }
      return type;
    },
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = {
        mobile: '',
        status: null
      };
      this.getList();
    }
  }
};
exports.default = _default;